// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"U0-z","dimensionLabel":"V0-z","styleChooserControlWrapper":"W0-z","styleChooserControl":"X0-z","disabled":"Y0-z","giftCard":"Z0-z","styleChooserText":"_0-z"};